import { Modal, Form, Input, Select, Tag, Alert, Spin } from 'antd';
import { authFetch } from '../../../../../common/request/authFetch';
import { useTranslation } from 'react-i18next';
import { PREDEFINED_REPORTS } from '../../../menuUsers/reports/ReportTypes';
import { useState } from 'react';
import { authRequest } from '../../../../../common/request/authRequest';
import { customRequest } from '../../../../../common/request/customRequest';
import { STATUS_CODE } from '../../../../../common/constants/statusCode';
import { SpinLZ } from '../../../../components/design/Spinner/SpinLZ';

export const AddReportTypesModal = (props : {project: any, onFinish: any}) => {
    
    const [form] = Form.useForm();
    const [errorMessage, setErrorMessage] = useState<any>(null);    
	const { t } = useTranslation();    
    
    const onFormFinish = async (values: any) => {

        const data = {
            ...values
        };
        const response = await customRequest(`${process.env.REACT_APP_API}/projects/${props.project.name}/report-types`, { method: 'PUT', data: data });        
		
		if (response?.statusCode === STATUS_CODE.BAD_REQUEST) {
			setErrorMessage(response.message);			
		} else if (response?.statusCode === STATUS_CODE.OK) {			
            props.onFinish();
		}         
    };

  return (
    <>
        <Modal 
            open={true} 
            onOk={() => form.submit()} 
            onCancel={props.onFinish} 
            afterClose={form.resetFields}>
            <h2>Tipos de Informe</h2>                        
            
            <Form 
                layout='vertical' 
                form={form} 
                onFinish={onFormFinish}
                autoComplete="off">
                <Form.Item 
                    initialValue={props.project.name}
                    label='Nombre' 
                    name='name' >
                    <Input disabled={true} className="disabled" />
                </Form.Item>                
                <Form.Item label='Por Local' name='reportTypes'>
					<Select mode="multiple" defaultValue={props.project.reportTypes}>
                        {Object.keys(PREDEFINED_REPORTS).map((key: string) => (
                                <Select.Option value={key}>
                                    {key}
                                </Select.Option>
                            )
                        )}	
					</Select>
				</Form.Item>	
            </Form>
            {errorMessage && <Alert
					type='error'
					message={errorMessage}
					banner
				/>
			}					
        </Modal>
    </>
  )
}

